import jordanPic from "@/public/images/artists/jordan.png";
import { Artist } from "@/types/types";

export const jordan = {
  id: "116",
  name: "Jordan",
  image: jordanPic,
  description: `Jordan's voice model is characterized by its deep, resonant tones, emotive delivery, and distinctive timbre. It embodies a deeply soulful quality, blending elements of R&B, soul, and alternative influences. The voice offers a rich and atmospheric sound, often conveying a melancholic undertone.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjordan-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: [
        "RnB",
        "Soul",
        "Alternative",
        "Unprocessed",
        "Falsetto",
        "Airy",
      ],
      secondary: ["Emotive", "Melancholic"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Very high",
      },
      specific: {
        low: 47,
        high: 76,
      },
    },
  },
} as const satisfies Artist;
